/**
 * useSupportEmail — fonte única dos e-mails de contato exibidos no footer.
 *
 * Origem (mesma lógica do componente legado footer/Emails.vue):
 *   supportEmail:  brandContacts.support.email → SUPPORT_EMAIL
 *   legalEmail:    appearance.footer_emails.LEGAL_EMAIL
 *   partnerEmail:  appearance.footer_emails.PARTNER_EMAIL
 * Retorna string vazia quando nenhuma fonte é válida.
 */
export function useSupportEmail() {
  const { brandContacts } = useFeatureFlagsNew();
  const appearance = useAppearanceStore();

  const supportEmail = computed<string>(() => {
    const fromContacts = brandContacts.value?.support?.email || '';

    if (fromContacts && isEmailValid(fromContacts)) return fromContacts;

    let legacy = appearance.appearance?.footer_emails?.SUPPORT_EMAIL || '';

    if (legacy && isEmailValid(legacy)) {
      legacy = legacy.replace('{site_url}', appUrl());

      return legacy;
    }

    return '';
  });

  const legalEmail = computed<string>(() => {
    const email = appearance.appearance?.footer_emails?.LEGAL_EMAIL || '';

    if (email && isEmailValid(email)) {
      return email.replace('{site_url}', appUrl());
    }

    return '';
  });

  const partnerEmail = computed<string>(() => {
    const email = appearance.appearance?.footer_emails?.PARTNER_EMAIL || '';

    if (email && isEmailValid(email)) {
      return email.replace('{site_url}', appUrl());
    }

    return '';
  });

  return { supportEmail, legalEmail, partnerEmail };
}
